function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback } from "react";
import { useSdkContext } from "~/components/contexts";
import { Variant } from "~/components/newsletter/newsletter-widget/enums";
import { isFacebookUserAgent } from "~/index";
import { useTrackImpressionEventByIntersection } from "~/lib/hooks";
import { DownloadAppWidget } from "./download-app-widget";
import { PrintEditionFooter } from "./print-edition-footer";
import { Container, Content, CopyRight, CopyRightContainer, DownloadAppWidgetContainer, Header, PrintEditionFooterContainer, StyledLogo, StyledNewsletterWidget, StyledSitemap, StyledSocialMedia, StyledSubscriptionWidget, WidgetContainer, Wrapper } from "./styles";
/**
 * You need to wrap with SdkContext before use this component
 */
export const BaseFooter = ({
  printEditionFooterConfig,
  ...newsletterProps
}) => {
  const {
    currentPageType,
    handleTrackGA4,
    isShowSubscription
  } = useSdkContext();
  const appDownloadWidgetImpressionGA4Event = useCallback(() => ({
    action: "imp",
    category: "appdl",
    customized_parameters: {
      page_type: currentPageType,
      position: "footer",
      ...(isFacebookUserAgent() && {
        inapp_browser: "fb"
      })
    },
    subcategory: ""
  }), [currentPageType]);
  const {
    captureTrackImpressionEventTargetElement: captureAppDownloadWidgetImpressionEvent
  } = useTrackImpressionEventByIntersection({
    ga4TrackingHandler: handleTrackGA4,
    getGa4Event: appDownloadWidgetImpressionGA4Event,
    options: {
      isSendGA4Tracking: true,
      shouldSendOnce: true
    }
  });
  return /*#__PURE__*/React.createElement(Container, {
    "data-qa": "base-footer"
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(StyledLogo, null), /*#__PURE__*/React.createElement(StyledSocialMedia, null)), (printEditionFooterConfig === null || printEditionFooterConfig === void 0 ? void 0 : printEditionFooterConfig.isEnabled) && /*#__PURE__*/React.createElement(PrintEditionFooterContainer, null, /*#__PURE__*/React.createElement(PrintEditionFooter, {
    config: printEditionFooterConfig
  })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(WidgetContainer, {
    $isShowSubscription: isShowSubscription
  }, isShowSubscription && /*#__PURE__*/React.createElement(StyledSubscriptionWidget, null), /*#__PURE__*/React.createElement(StyledNewsletterWidget, _extends({}, newsletterProps, {
    variant: Variant.Footer
  })), /*#__PURE__*/React.createElement(DownloadAppWidgetContainer, {
    ref: captureAppDownloadWidgetImpressionEvent
  }, /*#__PURE__*/React.createElement(DownloadAppWidget, null))), /*#__PURE__*/React.createElement(StyledSitemap, null)), /*#__PURE__*/React.createElement(CopyRightContainer, null, /*#__PURE__*/React.createElement(CopyRight, null, "Copyright \xA9 ", new Date().getFullYear(), " South China Morning Post Publishers Ltd. All rights reserved."))));
};
BaseFooter.displayName = "BaseFooter";